import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import {
  setReadOnly,
  scheduleFormAsync,
  saveForm,
} from "editor/actions/status";
import { updateFormAt } from "editor/actions/form";
import { hydrateAndLockItem } from "editor/actions/locking";
import { STATUS } from "config/constants";
import { API_TO_URL } from "config/constants/editor";
import ReadOnlyPanel from "editor/components/ReadOnlyPanel";
import Embargo from "editor/components/Embargo";

class ScheduledContainer extends React.Component {
  constructor() {
    super();
    this.state = { wasClicked: false };
    this.unschedule = this._unschedule.bind(this);
  }

  componentDidMount() {
    if (this.props.form.status === STATUS.SCHEDULED.slug) {
      this.props.setReadOnly(true);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.form.status === STATUS.SCHEDULED.slug &&
      !nextProps.status.isReadOnly
    ) {
      this.props.setReadOnly(true);
    }
  }

  _unschedule() {
    if (!this.state.wasClicked) {
      this.setState({ wasClicked: true });
      return this.props.hydrateAndLockItem(this.props.form.id).then(() => {
        this.props.updateFormAt("status", STATUS.IN_PROGRESS.slug);
        return this.props.saveForm(true);
      });
    }
  }

  render() {
    return (
      <>
        {this.props.children}
        <ReadOnlyPanel
          isVisible={this.props.form.status === STATUS.SCHEDULED.slug}
          description={
            <span>
              <Embargo
                contentType={API_TO_URL[this.props.status.editorType.name]}
                showScheduled
                form={this.props.form}
              />
              .
            </span>
          }
          button="Unschedule to edit"
          onClick={this.unschedule}
          key="read-only"
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  form: state.editor.form,
  status: state.editor.status,
});

const mapDispatchToProps = {
  setReadOnly,
  scheduleFormAsync,
  updateFormAt,
  saveForm,
  hydrateAndLockItem,
};

ScheduledContainer.propTypes = {
  form: PropTypes.shape({
    status: PropTypes.string,
    scheduled_date: PropTypes.any,
  }),
  status: PropTypes.shape({
    editorType: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
    isReadOnly: PropTypes.bool,
  }),
  hydrateAndLockItem: PropTypes.func.isRequired,
  setReadOnly: PropTypes.func.isRequired,
  scheduleFormAsync: PropTypes.func.isRequired,
  updateFormAt: PropTypes.func.isRequired,
  saveForm: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScheduledContainer);
